{
    "IncludeendedonholdLabel": "Include Ended On-Hold:",
    "IncludeescapedLabel": "Include Escaped:",
    "NAME": "UnreturnedCalls",
    "UnreturnedCalls_SectionHeader": "Unreturned Calls",
    "UnreturnedCalls_SectionPara": "You can choose whether some kinds of calls are considered as abandoned in \"Unreturned Lost Calls\" reports as well as the \"Unreturned Calls\" statistic."
}